exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "  .insta-1 {\n    fill: url(#instagram-linear-gradient);\n  }\n\n  .insta-2 {\n    fill: url(#instagram-linear-gradient-2);\n  }\n\n  .insta-3 {\n    fill: url(#instagram-linear-gradient-3);\n  }\n", ""]);
